import {useState} from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

export default function TextFieldSizes({
    takePhone,
}) {
    const [phone, setPhone] = useState('');
   
    const handlePhoneChange = (event) => {
        setPhone(event.target.value)
    }

    takePhone(phone)

  return (
    <Box
      component="form"
      sx={{
        '& .MuiTextField-root': { m: 1, width: '25ch' },
      }}
      noValidate
      autoComplete="off"
    >
      <div>
        <TextField
          label="Введіть номер телефону"
          id="outlined-size-small"
          defaultValue=""
          size="small"
          value={phone}
          onChange={handlePhoneChange}
        />
        
      </div>
    
     
    </Box>
  );
}